import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import {
  MODAL_DATA,
  MODAL_REF,
  ModalRef,
} from '@services/components/ModalService/modal.ref';

export interface ColorDeleteBlockedModalData {
  products: string[];
}

@Component({
  selector: 'app-color-delete-blocked-modal',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './color-delete-blocked-modal.component.html',
  styleUrl: './color-delete-blocked-modal.component.css',
})
export class ColorDeleteBlockedModalComponent {
  private readonly modalRef = inject(MODAL_REF) as ModalRef<void>;
  protected readonly data = inject<ColorDeleteBlockedModalData>(MODAL_DATA);

  public onClose(): void {
    this.modalRef.close({ reason: 'cancel' });
  }
}
